import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {UncountedStockReportData} from "./uncounted-stock-report.data";

@Injectable()
export class UncountedStockReportModel extends ReportModel<UncountedStockReportData> {
    constructor(injector: Injector) {
        super(injector, UncountedStockReportData);
    }
}
